import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_transload_order_receiving_grid_ComponentContextService } from './FootprintManager.transload_order_receiving_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { Materials_material_packagings_dd_singleComponent } from './Materials.material_packagings_dd_single.component'
import { FootprintManager_lots_dd_singleComponent } from './FootprintManager.lots_dd_single.component'
import { FootprintManager_vendorlots_dd_singleComponent } from './FootprintManager.vendorlots_dd_single.component'
import { Locations_locations_dd_singleComponent } from './Locations.locations_dd_single.component'
import { TransloadOrders_transload_composites_by_transload_id_dd_singleComponent } from './TransloadOrders.transload_composites_by_transload_id_dd_single.component'


interface IFootprintManager_transload_order_receiving_gridComponentEntity {
  Id?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualTargetLocationId?: number, ExpectedPackagedAmount?: number, LotId?: number, MaterialId?: number, OrderId?: number, OrderLineNumber?: number, ProjectId?: number, VendorLotId?: number, WarehouseId?: number, Material?: { LookupCode?: string }, ExpectedPackagedPack?: { ShortName?: string }, ActualPackagedPack?: { ShortName?: string }, Lot?: { LookupCode?: string }, VendorLot?: { LookupCode?: string, Vat?: string }, ActualTargetLocation?: { Name?: string }, ShipmentLine?: { ActualPackagedAmount?: number, ActualPackaged?: { Name?: string, ShortName?: string } }, OrderLine?: { GrossWeight?: number, NetWeight?: number, PackagedAmount?: number, WeightUomId?: number }}

interface IFootprintManager_transload_order_receiving_gridComponentInParams {
  orderId: number, shipmentId: number, orderStatusId: number, transload_id: number}


class FootprintManager_transload_order_receiving_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_transload_order_receiving_gridComponent;
  entity: IFootprintManager_transload_order_receiving_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    packaging_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    quantity_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    lot_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    vendorlot_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    location_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    licenseplate_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    outbound_shipment_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
  });

  override cells = {
    lineNumber: null,
    material: null,
    packaging: null,
    received: null,
    remaining: null,
    quantity: null,
    new_lot: null,
    lot: null,
    vendorlot: null,
    location: null,
    licenseplate: null,
    outbound_shipment: null,
  }

  get $fields_packaging_selector_inParams_materialId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $row.entity.MaterialId;
    
    return expr;
  }
  get $fields_lot_selector_inParams_materialId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $row.entity.MaterialId;
    
    return expr;
  }
  get $fields_lot_selector_inParams_vendorLotId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $row.cells.vendorlot.editControl.value;
    
    return expr;
  }
  get $fields_vendorlot_selector_inParams_materialId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $row.entity.MaterialId;
    
    return expr;
  }
  get $fields_vendorlot_selector_inParams_lotId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $row.cells.lot.editControl.value;
    
    return expr;
  }
  get $fields_location_selector_inParams_warehouseId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $row.entity.WarehouseId;
    
    return expr;
  }
  get $fields_location_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 3;
    
    return expr;
  }
  get $fields_outbound_shipment_selector_inParams_transload_id(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $grid.inParams.transload_id;
    
    return expr;
  }


  constructor(
    grid: FootprintManager_transload_order_receiving_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_transload_order_receiving_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.lineNumber = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lineNumber,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.material,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.packaging,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['packaging_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.received = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.received,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.remaining = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.remaining,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.quantity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.quantity,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['quantity_edit'] as DatexFormControl, null, false, false, '', '', null)
      );
    
    this.cells.new_lot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.new_lot,
      new ButtonModel('', new ButtonStyles(null, null), false, false, false, ' ', 'ms-Icon ms-Icon--Add', null)
,
null
      );
    
    this.cells.lot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lot,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['lot_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.vendorlot = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.vendorlot,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['vendorlot_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.location = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.location,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['location_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.licenseplate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.licenseplate,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['licenseplate_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.outbound_shipment = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.outbound_shipment,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['outbound_shipment_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    
    this.formGroup
      .controls['packaging_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_packaging_changed();
      });
    this.formGroup
      .controls['quantity_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_quantity_changed();
      });
    this.formGroup
      .controls['lot_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_lot_change();
      });
    this.formGroup
      .controls['vendorlot_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_vendorlot_change();
      });
    this.formGroup
      .controls['location_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_location_change();
      });
    this.formGroup
      .controls['licenseplate_edit']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_licenseplate_change();
      });
  }

  async $initializeExisting(entity: IFootprintManager_transload_order_receiving_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_transload_order_receiving_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      orderId:  $grid.inParams.orderId ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    const data = await this.$datasources.FootprintManager.ds_transload_order_receiving_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_transload_order_receiving_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.lineNumber.displayControl as TextModel).text = $row.entity.OrderLineNumber?.toString();
    (this.cells.material.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.packaging.displayControl as TextModel).text = $row.entity.ActualPackagedPack?.ShortName;
    (this.cells.packaging.editControl as SelectBoxModel).reset($row.entity.ActualPackagedPackId);
    (this.cells.lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.lot.editControl as SelectBoxModel).reset($row.entity.LotId);
    (this.cells.vendorlot.displayControl as TextModel).text = $row.entity.VendorLot?.LookupCode;
    (this.cells.vendorlot.editControl as SelectBoxModel).reset($row.entity.VendorLotId);
    (this.cells.location.displayControl as TextModel).text = $row.entity.ActualTargetLocation?.Name;
    (this.cells.location.editControl as SelectBoxModel).reset($row.entity.ActualTargetLocationId);
    (this.cells.licenseplate.displayControl as TextModel).text = '';
    (this.cells.licenseplate.editControl as TextBoxModel).reset('');

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_licenseplate_change(event = null) {
    return this.on_licenseplate_changeInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_licenseplate_changeInternal(
    $row: FootprintManager_transload_order_receiving_gridComponentRowModel,
  $grid: FootprintManager_transload_order_receiving_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_transload_order_receiving_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefinedTrimmed($row.cells.licenseplate.editControl.value)) {
          let exists = true;
  
          const licenseplate = (await $datasources.Locations.ds_get_licenseplates_by_lookupcode_and_warehouseId.get({
              warehouseId: $row.entity.WarehouseId,
              lookupcode: $row.cells.licenseplate.editControl.value
          })).result;
          exists = $utils.isDefined(licenseplate);
  
          if (exists) {
              $row.cells.licenseplate.styles.setAttentionClass();
          } else {
              $row.cells.licenseplate.styles.resetClasses();
          }
      } else {
          $row.cells.licenseplate.styles.resetClasses();
      }
  }
  on_location_change(event = null) {
    return this.on_location_changeInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_location_changeInternal(
    $row: FootprintManager_transload_order_receiving_gridComponentRowModel,
  $grid: FootprintManager_transload_order_receiving_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_transload_order_receiving_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefinedTrimmed($row.cells.location.editControl.value)) {
  
      const licenseplate = (await $datasources.Locations.ds_get_licenseplate_by_loose_locationId.get({
          locationId: $row.cells.location.editControl.value
      })).result;
      if ($utils.isDefined(licenseplate)) {
          $row.cells.licenseplate.editControl.reset(licenseplate[0].LookupCode);
          $row.cells.licenseplate.displayControl.text = licenseplate[0].LookupCode;
          $row.cells.licenseplate.editControl.readOnly = true;
          $row.cells.licenseplate.editControl.styles.setStyle('background', 'transparent');
      } else {
          $row.cells.licenseplate.editControl.reset('');
          $row.cells.licenseplate.editControl.readOnly = false;
          $row.cells.licenseplate.editControl.styles.resetStyle();
      }
  
  }
  
  
  }
  on_lot_change(event = null) {
    return this.on_lot_changeInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_changeInternal(
    $row: FootprintManager_transload_order_receiving_gridComponentRowModel,
  $grid: FootprintManager_transload_order_receiving_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_transload_order_receiving_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($utils.isDefined($row.cells.lot.editControl.value)) {
      const lot = (await $datasources.Lots.ds_get_lot_by_lotId.get({
          lotId: $row.cells.lot.editControl.value
      })).result;
      if ($utils.isDefined(lot)) {
          $row.cells.vendorlot.editControl.value = lot[0].VendorLotId;
      }
  } else {
      $row.cells.vendorlot.editControl.value = null;
  }
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_transload_order_receiving_gridComponentRowModel,
  $grid: FootprintManager_transload_order_receiving_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_transload_order_receiving_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Set remaining amount
  const actualPackagedAmount = $row.entity.ActualPackagedAmount;
  $row.cells.remaining.displayControl.text =
      `${$row.entity.ExpectedPackagedAmount} ${$row.entity.ExpectedPackagedPack?.ShortName}`;
  if ($row.entity.ExpectedPackagedAmount !== actualPackagedAmount &&
      actualPackagedAmount > 0) {
      $row.cells.remaining.styles.setAttentionClass();
  } else {
      $row.cells.remaining.styles.resetClasses();
  }
  
  // Set received amount
  $row.cells.received.displayControl.text =
      `${$row.entity.ShipmentLine.ActualPackagedAmount} ${$row.entity.ShipmentLine.ActualPackaged?.ShortName}`;
  
  
  // Set quantity to expected packaged amount from task
  $row.cells.quantity.displayControl.text = $row.entity.ExpectedPackagedAmount.toString();
  $row.cells.quantity.editControl.value = $row.entity.ExpectedPackagedAmount;
  
  const orderIsInProcessingStatus = $grid.inParams.orderStatusId === 2;
  if (orderIsInProcessingStatus) {
      const licenseplate = (await $datasources.Locations.ds_get_licenseplate_by_loose_locationId.get({
          locationId: $row.cells.location.editControl.value
      })).result;
      if ($utils.isDefined(licenseplate)) {
          $row.cells.licenseplate.editControl.reset(licenseplate[0].LookupCode);
          $row.cells.licenseplate.displayControl.text = licenseplate[0].LookupCode;
          $row.cells.licenseplate.editControl.readOnly = true;
          $row.cells.licenseplate.editControl.styles.setStyle('background', 'transparent');
      } else {
          $row.cells.licenseplate.editControl.reset('');
          $row.cells.licenseplate.editControl.readOnly = false;
          $row.cells.licenseplate.editControl.styles.resetStyle();
      }
  }
  
  var materialId = $row.entity.MaterialId;
  // Check if material is serial controlled and or lot controlled
  const material = (await $datasources.Materials.ds_get_material_by_materialId.get({
      materialId: materialId
  })).result;
  
  
  const materialControllerTypeId = material[0].ControllerTypeId;
  
  // Lot controlled
  if (materialControllerTypeId === 2 || materialControllerTypeId === 4) {
      $row.cells.lot.editControl.readOnly = false;
      $row.cells.lot.editControl.styles.resetStyle();
      $row.cells.vendorlot.editControl.readOnly = false;
      $row.cells.vendorlot.editControl.styles.resetStyle();
      $row.cells.new_lot.displayControl.styles.resetStyle();
      $row.cells.new_lot.displayControl.readOnly = false;
  } else {
      $row.cells.lot.editControl.readOnly = true;
      $row.cells.lot.editControl.styles.setStyle('background', 'transparent');
      $row.cells.vendorlot.editControl.readOnly = true;
      $row.cells.vendorlot.editControl.styles.setStyle('background', 'transparent');
      $row.cells.new_lot.displayControl.styles.setStyle('background', 'transparent');
      $row.cells.new_lot.displayControl.readOnly = true;
  }
  
  ($row as any).receivingReady = true;
  
  }
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: FootprintManager_transload_order_receiving_gridComponentRowModel,
  $grid: FootprintManager_transload_order_receiving_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_transload_order_receiving_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  $row.cells.quantity.displayControl.text = $row.cells.quantity.editControl.value;
  
  $row.cells.packaging.displayControl.text = $row.cells.packaging.editControl.displayText;
  $row.cells.licenseplate.displayControl.text = $row.cells.licenseplate.editControl.value;
  $row.cells.location.displayControl.text = $row.cells.location.editControl.displayText;
  $row.cells.lot.displayControl.text = $row.cells.lot.editControl.displayText;
  $row.cells.vendorlot.displayControl.text = $row.cells.vendorlot.editControl.displayText;
  
  
  const listOfSuccess = [];
  const listOfFailures = [];
  const dialogMessageList = [];
  const dialogMessageListDetails = [];
  
  
  try {
  
      // Confirming the receiving task
  
      if ($row.cells.quantity.editControl.value > 0) {
  
          const materials = (await $datasources.Materials.ds_get_material_by_materialId.get({
              materialId: $row.entity.MaterialId
          })).result;
          if ($utils.isDefined(materials)) {
  
              var controllerTypeId = materials[0].ControllerTypeId;
              var isFixedWeight = materials[0].IsFixedWeight;
              var isFixedLength = materials[0].IsFixedLength;
              var isFixedVolume = materials[0].IsFixedVolume;
  
          } else {
              throw new Error('Unable to determine material properties.')
          }
  
          // Check if material is serial controlled
          if (controllerTypeId === 3 || controllerTypeId === 4 || isFixedWeight === false || isFixedLength === false || isFixedVolume === false) {
  
              // Only pass in average weight from order line if the material is not fixed weight and the data is available on the order line
              if ($utils.isAllDefined($row.entity.OrderLine.GrossWeight, $row.entity.OrderLine.WeightUomId) && isFixedWeight === false) {
                  var averageGross = $row.entity.OrderLine.GrossWeight / $row.entity.OrderLine.PackagedAmount;
                  var weightUomId = $row.entity.OrderLine.WeightUomId;
              }
  
              const dialogResult = await $shell.FootprintManager.openserialnumbers_creation_gridDialog({
                  packagingId: $row.cells.packaging.editControl.value,
                  materialId: $row.entity.MaterialId,
                  packagedAmount: $row.cells.quantity.editControl.value,
                  averageGross: averageGross,
                  averageNet: averageGross,
                  weightUomId: weightUomId
              }, 'modal');
  
  
              var serialnumbersResult = dialogResult.serialNumbers;
              var confirmResult = dialogResult.confirm;
              if (confirmResult === false) {
                  throw new Error('Serial numbers were not created, please try again.')
              }
  
          }
          //Re-initialize variable
          var serialNumbers = [];
  
          if (confirmResult === true && $utils.isDefined(serialnumbersResult) && serialnumbersResult.length === $row.cells.quantity.editControl.value) {
  
              serialNumbers = serialnumbersResult;
  
          }
          if (confirmResult === true && (!$utils.isDefined(serialnumbersResult) || serialnumbersResult.length !== $row.cells.quantity.editControl.value)) {
  
              throw new Error('Error creating serial numbers, please try again.')
  
          }
  
          // Check if target license plate exists, use 2 different APIs based on result
          const licenseplates = (await $datasources.Locations.ds_get_licenseplates_by_lookupcode_and_warehouseId.get({
              warehouseId: $row.entity.WarehouseId,
              lookupcode: $row.cells.licenseplate.editControl.value
          })).result;
          if (!$utils.isDefined(licenseplates)) {
  
              // Handle associating the new licenseplate to the outbound shipment composite
              if ($utils.isDefined($row.cells.outbound_shipment.editControl.value)) {
                  var shipmentassociation = $row.cells.outbound_shipment.editControl.value;
                  var shipmentId = shipmentassociation.Shipmentid;
              }
  
              const result = (await $flows.TransloadOrders.receive_on_new_licenseplate_flow({
                  licenseplateLookupcode: $row.cells.licenseplate.editControl.value,
                  locationId: $row.cells.location.editControl.value,
                  lotId: $row.cells.lot.editControl.value,
                  packagedAmount: $row.cells.quantity.editControl.value,
                  packagingId: $row.cells.packaging.editControl.value,
                  taskId: $row.entity.Id,
                  serialNumbers: serialNumbers,
                  shipmentId: shipmentId
              }));
  
              if ($utils.isDefined(result.reasons)) {
  
                  throw new Error((await $flows.Utilities.grammar_format_string_array_flow({ values: result.reasons })).formattedValue);
  
              }
              else {
  
                  await $row.refresh();
              }
  
  
  
          }
          else {
  
              const licenseplate = $row.cells.licenseplate.editControl.value;
  
              throw new Error(`Receiving onto the existing licenseplate ${licenseplate} is currently not suppported, please use the mobile web instead.`);
  
  
          }
  
  
  
      }
  
  
  } catch (error) {
      listOfFailures.push($row.entity.OrderLineNumber);
  
      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
      const errorDescription = ''.concat('Line ', $row.entity.OrderLineNumber.toString(), ' - ', errorMessage);
      dialogMessageList.push(errorDescription)
      dialogMessageListDetails.push({ message: errorDescription, detail: errorDetail });
  }
  
  if (listOfFailures.length > 0) {
      $shell.FootprintManager.openErrorDialog('Receiving', 'Selected task could not be received.', dialogMessageList, '', dialogMessageListDetails);
  }
  
  
  }
  on_quantity_changed(event = null) {
    return this.on_quantity_changedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_quantity_changedInternal(
    $row: FootprintManager_transload_order_receiving_gridComponentRowModel,
  $grid: FootprintManager_transload_order_receiving_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_transload_order_receiving_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // set-row-remaining.flow.json
  const actualPackagedAmount = $row.cells.quantity.editControl.value;
  $row.cells.remaining.displayControl.text =
      `${$row.entity.ExpectedPackagedAmount} ${$row.entity.ExpectedPackagedPack?.ShortName}`;
  if ($row.entity.ExpectedPackagedAmount !== actualPackagedAmount &&
      actualPackagedAmount > 0) {
      $row.cells.remaining.styles.setAttentionClass();
  } else {
      $row.cells.remaining.styles.resetClasses();
  }
  
  
  var materialId = $row.entity.MaterialId;
  var packagingId = $row.cells.packaging.editControl.value;
  
  
  // Default the decimal formatting
  const decimalFormat = (await $flows.Materials.get_material_packaging_decimal_precision_formatted({
      materialId: materialId,
      packagingId: packagingId
  }));
  
  if ($utils.isDefined(decimalFormat)) {
      $row.cells.quantity.editControl.format = decimalFormat.format;
  
  }
  
  
  }
  on_vendorlot_change(event = null) {
    return this.on_vendorlot_changeInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_vendorlot_changeInternal(
    $row: FootprintManager_transload_order_receiving_gridComponentRowModel,
  $grid: FootprintManager_transload_order_receiving_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_transload_order_receiving_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $row.cells.lot.editControl.value = null;
  
  
  }
  on_new_lot_clicked(event = null) {
    return this.on_new_lot_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_new_lot_clickedInternal(
    $row: FootprintManager_transload_order_receiving_gridComponentRowModel,
  $grid: FootprintManager_transload_order_receiving_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_transload_order_receiving_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  const materialId = $row.entity.MaterialId;
  
  
  const dialogResult = await $shell.FootprintManager.openlot_creation_formDialog({ materialId: materialId }, 'modal');
  const userConfirmed = dialogResult.confirm;
  const lotId = dialogResult.lotId;
  
  
  
  if (userConfirmed === true && $utils.isDefined(lotId)) {
      const lot = (await $datasources.Lots.ds_get_lot_by_lotId.get({ lotId: lotId })).result;
      const vendorLotId = lot[0].VendorLotId;
  
      $row.cells.lot.editControl.value = lotId;
      $row.cells.lot.displayControl.text = lot[0].LookupCode;
      $row.cells.vendorlot.editControl.value = vendorLotId;
      $row.cells.vendorlot.displayControl.text = lot[0].VendorLot.LookupCode;
      const payload: any = {};
  
      payload.LotId = lotId;
      payload.VendorLotId = vendorLotId;
  
      try {
  
          await $flows.Utilities.crud_update_flow({
              entitySet: 'Tasks',
              id: $row.entity.Id,
              entity: payload
          });
  
  
      } catch (error) {
          $shell.FootprintManager.showErrorDetails('Save', 'Error on save.', error);
          throw error; // to prevent displayMode 
      }
  
  } else {
      throw new Error('Error creating new lot')
  }
  
  }
  on_packaging_changed(event = null) {
    return this.on_packaging_changedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_packaging_changedInternal(
    $row: FootprintManager_transload_order_receiving_gridComponentRowModel,
  $grid: FootprintManager_transload_order_receiving_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_transload_order_receiving_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  var materialId = $row.entity.MaterialId;
  var packagingId = $row.cells.packaging.editControl.value;
  
  
  
  
  
  // Default the decimal formatting
  const decimalFormat = (await $flows.Materials.get_material_packaging_decimal_precision_formatted({
      materialId: materialId,
      packagingId: packagingId
  }));
  
  if ($utils.isDefined(decimalFormat)) {
      $row.cells.quantity.editControl.format = decimalFormat.format;
  
  }
  
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Materials_material_packagings_dd_singleComponent),
    forwardRef(() => FootprintManager_lots_dd_singleComponent),
    forwardRef(() => FootprintManager_vendorlots_dd_singleComponent),
    forwardRef(() => Locations_locations_dd_singleComponent),
    forwardRef(() => TransloadOrders_transload_composites_by_transload_id_dd_singleComponent),
  ],
  selector: 'FootprintManager-transload_order_receiving_grid',
  templateUrl: './FootprintManager.transload_order_receiving_grid.component.html'
})
export class FootprintManager_transload_order_receiving_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_transload_order_receiving_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_transload_order_receiving_gridComponentInParams = { orderId: null, shipmentId: null, orderStatusId: null, transload_id: null };


  //#region Variables
  vars: { entities?: { Id?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualTargetLocationId?: number, ExpectedPackagedAmount?: number, LotId?: number, MaterialId?: number, OrderId?: number, OrderLineNumber?: number, ProjectId?: number, VendorLotId?: number, WarehouseId?: number, Material?: { LookupCode?: string }, ExpectedPackagedPack?: { Name?: string }, ActualPackagedPack?: { Name?: string }, Lot?: { LookupCode?: string }, VendorLot?: { LookupCode?: string }, ActualTargetLocation?: { Name?: string }, ShipmentLine?: { ActualPackagedAmount?: number, ActualPackaged?: { Name?: string } } }[], totalCount?: number } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     lineNumber: new GridHeaderModel(new HeaderStyles(null, null), 'lineNumber', 'Line #', false, false, null, false),       material: new GridHeaderModel(new HeaderStyles(null, null), 'material', 'Material', false, false, null, false),       packaging: new GridHeaderModel(new HeaderStyles(null, null), 'packaging', 'Packaging', true, false, null, false),       received: new GridHeaderModel(new HeaderStyles(null, null), 'received', 'Received', false, false, null, false),       remaining: new GridHeaderModel(new HeaderStyles(null, null), 'remaining', 'Remaining', false, false, null, false),       quantity: new GridHeaderModel(new HeaderStyles(null, null), 'quantity', 'Receive quantity', true, false, null, false),       new_lot: new GridHeaderModel(new HeaderStyles(null, null), 'new_lot', ' ', false, false, null, false),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'lot', 'Lot', true, false, null, false),       vendorlot: new GridHeaderModel(new HeaderStyles(null, null), 'vendorlot', 'Vendor lot', true, false, null, false),       location: new GridHeaderModel(new HeaderStyles(null, null), 'location', 'Receive location', true, false, null, false),       licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'licenseplate', 'Receive LP', true, false, null, false),       outbound_shipment: new GridHeaderModel(new HeaderStyles(null, null), 'outbound_shipment', 'Outbound shipment', true, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_transload_order_receiving_gridComponentRowModel[] = [];

  @Input('orderId') set $inParams_orderId(value: any) {
    this.inParams['orderId'] = value;
  }
  get $inParams_orderId(): any {
    return this.inParams['orderId'] ;
  }
  @Input('shipmentId') set $inParams_shipmentId(value: any) {
    this.inParams['shipmentId'] = value;
  }
  get $inParams_shipmentId(): any {
    return this.inParams['shipmentId'] ;
  }
  @Input('orderStatusId') set $inParams_orderStatusId(value: any) {
    this.inParams['orderStatusId'] = value;
  }
  get $inParams_orderStatusId(): any {
    return this.inParams['orderStatusId'] ;
  }
  @Input('transload_id') set $inParams_transload_id(value: any) {
    this.inParams['transload_id'] = value;
  }
  get $inParams_transload_id(): any {
    return this.inParams['transload_id'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_transload_order_receiving_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Receiving tasks';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.orderId)) {
        this.$missingRequiredInParams.push('orderId');
      }
      if(isNil(this.inParams.shipmentId)) {
        this.$missingRequiredInParams.push('shipmentId');
      }
      if(isNil(this.inParams.orderStatusId)) {
        this.$missingRequiredInParams.push('orderStatusId');
      }
      if(isNil(this.inParams.transload_id)) {
        this.$missingRequiredInParams.push('transload_id');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      orderId:  $grid.inParams.orderId ,
      fullTextSearch:  $grid.fullTextSearch ,
    };
    try {
      const data = await this.$datasources.FootprintManager.ds_transload_order_receiving_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_transload_order_receiving_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_transload_order_receiving_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_transload_order_receiving_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_transload_order_receiving_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  const orderIsInProcessingStatus = $grid.inParams.orderStatusId === 2;
  if (orderIsInProcessingStatus) {
  
      $grid.canEdit = true;
  
      $grid.headers.quantity.required = true;
      $grid.headers.packaging.required = true;
      $grid.headers.lot.required = true;
      $grid.headers.vendorlot.required = true;
      $grid.headers.licenseplate.required = true;
      $grid.headers.location.required = true;
  
  } else {
      
      $grid.canEdit = false;
  
      $grid.headers.quantity.required = false;
      $grid.headers.packaging.required = false;
      $grid.headers.lot.required = false;
      $grid.headers.vendorlot.required = false;
      $grid.headers.licenseplate.required = false;
      $grid.headers.location.required = false;
  
  }
  
  
  
  
  
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
